/**
*功能名称：数据源管理
*创 建 人：whr
*日    期：2023/06/15 10:15:17
*/

import {DbCenterBaseApiV2} from "../DbCenterBaseApiV2";
import {Methods} from "@newview/infrastructure";
export class DbBackupdatainfoApi extends DbCenterBaseApiV2 {
    public get ControllerName(): any {
        return 'dbBackupdatainfo';
    }

    /**
     * 下载文件
     * @param params
     */
    public async downloadFile(params) {
        return await this.send(params, "downloadFile", Methods.GET,"",{responseType: 'blob'});
    }

    /**
     * 分页查询
     * @param params
     */
    public async getEntitiesPage(params) {
        return await this.send(params, "getEntitiesPage", Methods.GET);
    }

    /**
     * 获取备份文件
     * @param params
     */
    public async getBackUpDataByDbId(params) {
        return await this.send(params, "getBackUpDataByDbId", Methods.GET);
    }

    /**
     * 执行备份文件
     * @param params
     */
    public async executeBackUp(params) {
        return await this.send(params, "executeBackUp", Methods.POST);
    }

    /**
     * 删除备份库
     * @param params
     */
    public async deleteBackUp(params) {
        return await this.send(params, "deleteBackUp", Methods.POST);
    }

    /**
     * 数据迁移
     * @param params
     */
    public async dataMigrate(params) {
        return await this.send(params, "dataMigrate", Methods.POST);
    }

    /**
     * 获取执行进度
     * @param params
     */
    public async getExecuteProgress(ProgressKey) {
        return await this.send({ProgressKey}, "getExecuteProgress", Methods.GET);
    }

    /**
     * 获取数据库表信息
     * @param params
     */
    public async getTableByDbName(params) {
        return await this.send(params, "getTableByDbName", Methods.GET);
    }

}
